import { render } from "./ContactSection.vue?vue&type=template&id=5cd986e8&scoped=true"
const script = {}

import "./ContactSection.vue?vue&type=style&index=0&id=5cd986e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cd986e8"]])

export default __exports__